// removed by extract-text-webpack-plugin
module.exports = {"container":"_3kFO0","moreButton":"_3LwV1","overlay":"_2JDpA","titleContainer":"_2rtGi","title":"_4jCg7","description":"_2Z4Hj","statistics":"_2-oj5"};


//////////////////
// WEBPACK FOOTER
// ./app/components/category-list-item/category-list-item.scss
// module id = 1443
// module chunks = 0